$(document).ready(function () {
  $donationPage = $(".donation-page");

  if ($donationPage.length) {
    $form = $donationPage.find("form");
    $form.find("input[name='donation-amount']").val(getRandomDonationAmount());
  }
});

function getRandomDonationAmount() {
  var amounts = [5, 10, 15, 20, 25];
  return amounts[Math.floor(Math.random() * amounts.length)];
}

function startDonationCountdown() {
  var $number = $(".countdown-number");

  var counter = 5;

  setInterval(function() {
    counter--;
    
    $number.text(counter);
    if (counter === 1) {
      location.reload();
    }
  }, 1000);
}